import { Component, inject, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppCommonModule } from '@app/components/app.common.module';
import { BaseComponent } from '@app/components/base/base.component';
import { environment } from '@env/environment.local';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { PlanPisoService } from '../plan-piso.service';
import { DealerService } from '@app/pages/dealers/services/dealer.service';
import { ModalService } from '@app/components/modal/modal.service';

@Component({
  selector: 'app-list-plan-piso',
  standalone: true,
  imports: [AppCommonModule],
  templateUrl: './list-plan-piso.component.html',
  styleUrl: './list-plan-piso.component.css'
})
export class ListPlanPisoComponent extends BaseComponent implements OnInit {
  private readonly service = inject(PlanPisoService);
  private readonly dealerService = inject(DealerService);
  private readonly router = inject(Router);

  isLoading: boolean = false;
  hasData: boolean = false;
  data: any[] = [];
  dealers: any[] = [];
  dealerOptions: any[] = [];
  pageSize: number = environment.pageSize;
  pageIndex: number = 1;
  total: number = 0;

  // Filtros - usando el mismo patrón que sub-brand
  params: any = {
    name: null,
    dealerId: null,
    wholeSaleKeyMxn: null,
    wholeSaleKeyUsd: null,
    active: null,
    pageSize: environment.pageSize,
    page: 1,
  };

  searchName: any = { placeholder: 'Buscar por nombre', value: '' };
  searchKeyMxn: any = { placeholder: 'Buscar por clave MXN', value: '' };
  searchKeyUsd: any = { placeholder: 'Buscar por clave USD', value: '' };
  reset: boolean = false;

  // Opciones para selects
  statusOptions = [
    { label: 'Activo', value: 1 },
    { label: 'Inactivo', value: 0 }
  ];

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
  }

  ngOnInit(): void {
    this.sendDataToMenu();
    this.loadDealers();
    this.getList();
  }

  loadDealers(): void {
    this.dealerService.getDealers().subscribe({
      next: (response) => {
        this.dealers = response.data || [];
        this.dealerOptions = this.dealers.map((dealer: any) => ({
          label: dealer.name,
          value: dealer.id
        })).sort((a, b) => a.label.localeCompare(b.label));
      },
      error: () => {
        this.dealers = [];
        this.dealerOptions = [];
      },
    });
  }

  getDealerName(dealerId: number): string {
    if (!dealerId) return '-';
    const dealer = this.dealers.find((d: any) => d.id === dealerId);
    return dealer ? dealer.name : dealerId.toString();
  }

  getBranchNamesDisplay(dealerBranchNames: string[] | string | null | undefined): string {
    if (!dealerBranchNames) return 'Sin asignar';
    if (typeof dealerBranchNames === 'string') return dealerBranchNames || 'Sin asignar';
    return Array.isArray(dealerBranchNames) && dealerBranchNames.length > 0
      ? dealerBranchNames.join(', ')
      : 'Sin asignar';
  }

  getList() {
    this.isLoading = true;
    this.service.getAllWholesalesWithFilters(this.params).subscribe({
      next: (response) => {
        this.data = (response.data || []).sort((a: any, b: any) => {
          const nameA = (a.name || '').toLowerCase();
          const nameB = (b.name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.total = response.totalElements || this.data.length;
        this.pageIndex = response.page || this.pageIndex;
        this.hasData = this.data.length > 0;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.showNotificationError('Error al cargar los planes piso.');
      },
    });
  }

  addNewWholesale() {
    this.router.navigate(['catalogs/plan-piso/new']);
  }

  view(id: number) {
    this.router.navigate([`catalogs/plan-piso/view/${id}`]);
  }

  filter(value: any, typeField: string) {
    switch (typeField) {
      case 'name':
        this.params.name = value;
        break;
      case 'dealerId':
        this.params.dealerId = value;
        break;
      case 'wholeSaleKeyMxn':
        this.params.wholeSaleKeyMxn = value;
        break;
      case 'wholeSaleKeyUsd':
        this.params.wholeSaleKeyUsd = value;
        break;
      case 'active':
        this.params.active = value;
        break;
      case 'default':
        break;
    }
  }

  search() {
    this.params.page = 1;
    this.pageIndex = 1;
    this.getList();
  }

  resetFilters() {
    // Resetear parámetros de búsqueda
    this.params = {
      name: null,
      dealerId: null,
      wholeSaleKeyMxn: null,
      wholeSaleKeyUsd: null,
      active: null,
      pageSize: this.pageSize,
      page: 1,
    };

    // Resetear estado visual de los filtros
    this.searchName = { placeholder: 'Buscar por nombre', value: '' };
    this.searchKeyMxn = { placeholder: 'Buscar por clave MXN', value: '' };
    this.searchKeyUsd = { placeholder: 'Buscar por clave USD', value: '' };

    // Activar señal de reset para los componentes de filtro
    this.reset = true;

    // Resetear la señal después de un breve delay para que los componentes la detecten
    setTimeout(() => {
      this.reset = false;
    }, 100);

    this.pageIndex = 1;
    this.getList();
  }

  handlePage(e: any) {
    this.params.page = e.pageIndex + 1;
    this.params.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex + 1;
    this.getList();
  }
}

